import { slider } from './mock/sliderData.js';


angular.module('Toke').factory('sliderRepository', function ($q) {

    function getSlider() {
        return $q.resolve(slider)
    }

    // para lista futura
    // function getSliderFromList() {

    //     const listUrl =
    //         baseUrl +
    //         "/_api/web/lists/getbytitle('Slider')/items" +
    //         "?$select=Title,Url,ParentId,Order,IsActive" +
    //         "&$orderby=Order asc";

    //     return $http({
    //         method: 'GET',
    //         url: listUrl,
    //         headers: {
    //             Accept: 'application/json;odata=nometadata'
    //         }
    //     }).then(function (response) {
    //         return response.data.value;
    //     });
    // }



    return {
        getSlider: getSlider
    };

});

